/* src/app/components/textoaceptacion/textoaceptacion.component.scss */
/*# sourceMappingURL=textoaceptacion.component.css.map */
